import {combineEpics} from "redux-observable"
import refdbEpic from "../../metstat/redux/refdb.epic"

import coreEpic from "../../core/epics/core.epic"
import commonEpic from "../../common/redux/common.epic"
import commonsEpic from "../../@biocrates-common-repo/redux/commons.epic"

export default combineEpics(refdbEpic, coreEpic, commonEpic, commonsEpic)
